import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { paymentMethodCatalogFieldsMap } from 'app/configs/datasets/domain_configs/fields/payment_methods/catalog.fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	paymentMethodCatalogFieldsMap.get('visible_families'),
	paymentMethodCatalogFieldsMap.get('scenario'),
];

const paymentMethodCatalogForm: IFormConfig = {
	editTitle: 'Modifica metodi di incasso visibili',
	fields: formFields
};

export default paymentMethodCatalogForm;
